import { PurchasingCalendarContainer } from "./container";
import { PageFrame } from "../../components/page_frame";

export const PurchasingCalendarPage = () => {
  return (
    <PageFrame>
      <PurchasingCalendarContainer />
    </PageFrame>
  );
};
